@if (detail(); as item) {
  <main class="knowledge-check-page">
    <div class="knowledge-check-topbar">
      <a class="ghost-button as-link" [routerLink]="['/learning', item.enrollment.id, 'lessons', item.lesson.id]">← Zurück zur Lektion</a>
      <span class="kicker">Modul {{ item.enrollment.moduleNumber }} · {{ item.enrollment.courseTitle }}</span>
    </div>

    <section class="knowledge-check-hero">
      <span class="kicker">Lektion {{ item.lesson.lessonOrder }}</span>
      <h1>Wissens-Check</h1>
      <p>{{ item.lesson.title }}</p>
      <div class="knowledge-check-progress-row">
        <span>Frage {{ currentQuestionIndex() + 1 }} von {{ item.lesson.questions.length }}</span>
        <span>{{ item.lesson.completed ? 'Bereits abgeschlossen' : 'Nimm dir Zeit für deine Antworten.' }}</span>
      </div>
      <div class="progress-track"><div class="progress-fill" [style.width.%]="item.lesson.questions.length ? (currentQuestionIndex() + 1) / item.lesson.questions.length * 100 : 0"></div></div>
    </section>

    @if (item.lesson.completed) {
      @if (result(); as resultItem) {
        <section class="knowledge-result-card">
          <div class="knowledge-result-summary">
            <div>
              <span class="kicker">Dein Ergebnis</span>
              <h2>{{ resultItem.passed ? 'Wissens-Check bestanden' : 'Wissens-Check nicht bestanden' }}</h2>
              <p>{{ resultItem.message }}</p>
            </div>
            <strong class="knowledge-result-score">{{ resultItem.scorePercent }} %</strong>
          </div>

          @if (resultItem.passed && !item.lesson.nextLessonId && item.enrollment.finalQuiz?.available && !item.enrollment.finalQuiz?.passed) {
            <section class="final-quiz-ready-panel" aria-live="polite">
              <div>
                <span class="kicker">Alle Lektionen abgeschlossen</span>
                <h3>Die Abschlussprüfung ist jetzt freigeschaltet</h3>
                <p>
                  Du hast die letzte Lektion bestanden. Absolviere jetzt die Abschlussprüfung, um das Modul vollständig abzuschließen.
                </p>
              </div>
              <a
                class="primary-button as-link whitespace-nowrap"
                [routerLink]="['/learning', item.enrollment.id, 'final-knowledge-check']"
              >
                Zur Abschlussprüfung →
              </a>
            </section>
          }

          <div class="knowledge-result-list">
            @for (questionResultItem of resultItem.questions; track questionResultItem.questionId; let questionIndex = $index) {
              @if (questionForResult(item, questionResultItem.questionId); as question) {
                <article class="knowledge-result-question" [class.correct]="questionResultItem.correct">
                  <div class="knowledge-question-number">Frage {{ questionIndex + 1 }}</div>
                  <h3>{{ question.text }}</h3>
                  <p class="knowledge-result-answer">
                    <strong>Deine Antwort:</strong>
                    {{ optionText(question, questionResultItem.selectedOptionId) }}
                  </p>
                  <p class="knowledge-result-answer">
                    <strong>Richtige Antwort:</strong>
                    {{ optionText(question, questionResultItem.correctOptionId) }}
                  </p>
                  <p class="knowledge-feedback" [class.correct]="questionResultItem.correct">
                    {{ questionResultItem.correct ? 'Richtig beantwortet.' : 'Falsch beantwortet.' }}
                    {{ questionResultItem.explanation }}
                  </p>
                </article>
              }
            }
          </div>

          <div class="knowledge-check-actions">
            <a class="ghost-button as-link" [routerLink]="['/learning', item.enrollment.id, 'lessons', item.lesson.id]">Zurück zur Lektion</a>
          </div>
        </section>
      } @else {
        <div class="empty">Ergebnis wird geladen.</div>
      }
    } @else if (item.lesson.questions.length) {
      <section class="knowledge-check-card">
        @if (currentQuestion(item.lesson.questions); as question) {
          <article class="knowledge-question">
            <div class="knowledge-question-number">Frage {{ currentQuestionIndex() + 1 }} von {{ item.lesson.questions.length }}</div>
            <h2>{{ question.text }}</h2>
            <div class="knowledge-options">
              @for (option of question.options; track option.id; let optionIndex = $index) {
                <label class="knowledge-option" [class.selected]="selectedOptionId(question.id) === option.id">
                  <input type="radio" [name]="'question-' + question.id" [checked]="selectedOptionId(question.id) === option.id" (change)="selectOption(question.id, option.id)">
                  <span class="knowledge-option-letter">{{ ['A', 'B', 'C', 'D'][optionIndex] }}</span>
                  <span>{{ option.text }}</span>
                </label>
              }
            </div>
            @if (questionResult(question.id); as questionResultItem) {
              <p class="knowledge-feedback" [class.correct]="questionResultItem.correct">{{ questionResultItem.correct ? 'Richtig.' : 'Noch nicht richtig.' }} {{ questionResultItem.explanation }}</p>
            }
          </article>
        }
      </section>

      @if (error()) { <p class="field-error">{{ error() }}</p> }
      @if (result(); as resultItem) { <div class="info-message">{{ resultItem.message }} Ergebnis: {{ resultItem.scorePercent }} %</div> }
      <div class="knowledge-check-actions">
        <a class="ghost-button as-link" [routerLink]="['/learning', item.enrollment.id, 'lessons', item.lesson.id]">Später fortsetzen</a>
        <div class="knowledge-check-step-actions">
          <button class="ghost-button" type="button" (click)="goToPreviousQuestion()" [disabled]="currentQuestionIndex() === 0 || saving()">
            Zurück
          </button>
          @if (isLastQuestion(item.lesson.questions)) {
            <button class="primary-button" type="button" (click)="submitQuiz(item)" [disabled]="saving()">
              Wissens-Check auswerten
            </button>
          } @else {
            <button class="primary-button" type="button" (click)="goToNextQuestion(item)" [disabled]="saving()">
              Nächste Frage
            </button>
          }
        </div>
      </div>
    }
  </main>
} @else { <div class="empty">Wissens-Check wird geladen.</div> }
